"use client";

import { type UseContactSalesFormReturn } from "../hooks/useContactSalesForm";
import { fieldConfig } from "../shared/constants";

type Step1Props = Pick<UseContactSalesFormReturn, "form" | "validators" | "t"> & {
  showTestVariant?: boolean;
};

export function Step1({ form, validators, t, showTestVariant }: Step1Props) {
  return (
    <>
      <form.AppField
        name={fieldConfig.website.name}
        validators={{
          onMount: validators.website,
          onChange: validators.website,
        }}
      >
        {field => (
          <field.Input
            name={fieldConfig.website.name}
            label={t("fields.website.label")}
            placeholder={showTestVariant ? undefined : t("fields.website.placeholder")}
            required={fieldConfig.website.required}
            showTestVariant={showTestVariant}
          />
        )}
      </form.AppField>
      <form.AppField
        name={fieldConfig.email.name}
        validators={{
          onMount: validators.email,
          onChange: validators.email,
        }}
      >
        {field => (
          <field.Input
            name={fieldConfig.email.name}
            label={t("fields.email.label")}
            placeholder={showTestVariant ? undefined : t("fields.email.placeholder")}
            type={fieldConfig.email.type}
            required={fieldConfig.email.required}
            showTestVariant={showTestVariant}
          />
        )}
      </form.AppField>
    </>
  );
}
